import { ChevronDown } from 'lucide-react'
import { useIsMobile } from '@/hooks/useIsMobile'
import BottomSheet from '@/components/Common/BottomSheet'

// Extraído literalmente del dropdown de timeframe de ChartPage.jsx para que
// ChartPublicPage.jsx ofrezca exactamente los mismos timeframes (ver
// constants/timeframes.js). El estado de apertura/cierre y el ref de
// "clic fuera para cerrar" los sigue manejando cada página (igual que ya
// hacían), este componente es puramente presentacional.
export default function TimeframeSelector({ timeframes, value, onChange, showMenu, onToggleMenu, menuRef, buttonClassName, menuClassName }) {
  const isMobile = useIsMobile()
  const current = timeframes.find(t => t.value === value) || timeframes[0]

  const grid = (
    <div className="grid grid-cols-4 gap-1 w-48">
      {timeframes.map(tf => (
        <button
          key={tf.value}
          data-testid={`tf-option-${tf.value}`}
          onClick={() => onChange(tf.value)}
          className={`px-2 py-1.5 text-xs font-semibold rounded-lg transition-colors text-center ${
            tf.value === value
              ? 'text-[var(--green-deep)]'
              : 'text-[var(--txt-dim)] hover:bg-[var(--green-panel-2)]'
          }`}
          style={tf.value === value ? { background: 'var(--gold)' } : undefined}
        >
          {tf.label}
        </button>
      ))}
    </div>
  )

  return (
    <div className="relative" ref={menuRef}>
      <button
        data-testid="tf-trigger"
        onClick={onToggleMenu}
        className={buttonClassName || "flex items-center gap-1.5 px-3 py-2.5 md:py-1.5 bg-white dark:bg-gray-800 border border-slate-200 dark:border-gray-700 rounded-lg hover:bg-slate-50 dark:hover:bg-gray-750 text-sm font-semibold text-slate-700 dark:text-gray-200 min-w-[62px]"}
      >
        {current.label}
        <ChevronDown size={12} className={`transition-transform duration-150 ${showMenu ? 'rotate-180' : ''}`} />
      </button>
      {showMenu && (isMobile ? (
        <BottomSheet title="Timeframe" onClose={onToggleMenu}>
          <div className="p-3 grid grid-cols-4 gap-2">
            {timeframes.map(tf => (
              <button
                key={tf.value}
                data-testid={`tf-option-${tf.value}`}
                onClick={() => onChange(tf.value)}
                className={`px-2 py-2.5 min-h-[44px] text-xs font-semibold rounded-lg transition-colors text-center ${
                  tf.value === value
                    ? 'text-[var(--green-deep)]'
                    : 'text-[var(--txt-dim)] hover:bg-[var(--green-panel-2)]'
                }`}
                style={tf.value === value ? { background: 'var(--gold)' } : undefined}
              >
                {tf.label}
              </button>
            ))}
          </div>
        </BottomSheet>
      ) : (
        <div className={`absolute top-full left-0 mt-1 w-48 rounded-xl shadow-xl z-[60] p-2 ${menuClassName || 'quantum-menu'}`}>
          {grid}
        </div>
      ))}
    </div>
  )
}
